<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
    ></loading>

    <gd-modal
      :title="$t('frontend_grooveblog_import_error_modal_title')"
      ref="reasonModal"
      name="reasonModal"
      height="auto"
      @closed="closeModal"
    >
      <div
        v-if="reason"
        class="overflow-y-auto flex flex-col align-center px-6 py-4"
        style="max-height: 400px; max-width: 600px"
      >
        <div class="py-2" v-for="(error, index) in reason" :key="index">
          <span class="font-bold">
            {{
              $t('frontend_grooveblog_imports_listing_error_message', {
                row: error.row,
              })
            }}
          </span>
          {{ error.error }}
        </div>
      </div>
    </gd-modal>
    <div class="vclient-table">
      <client-table
        class="grooveblog-ImportPosts-table"
        :tableRef="'ImportPostsTable'"
        :tableColumns="importTableColumns"
        :tableOptions="importTableOptions"
        :tableData="importedFiles"
        :tableCondition="importedFiles.length"
        :slotData="slotData"
      >
      </client-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ClientTable from '@groovepages/gd-ui-kit/components/tables/ClientTable.vue';
import themeConfig from '@/theme/themeConfig.js';

export default {
  metaInfo() {
    return {
      title: this.$t('frontend_grooveblog_import_listing_metainfo'),
    };
  },

  components: {
    Loading,
    ClientTable,
  },

  data() {
    return {
      isLoading: false,
      fullPageLoader: true,
      loaderColor: themeConfig.appPrimaryColor,
      reason: '',
      importedFiles: [],
      importTableColumns: [
        'csv_name',
        'no_of_posts',
        'no_of_discards',
        'created_at',
        'status',
        'reject_reason'
      ],
      importTableOptions: {
        sortIcon: {base: 'fa', is: 'fa-sort', up: 'fa-sort-asc', down: 'fa-sort-desc'},
        sortable: ['no_of_posts', 'created_at'],
        headings: {
          csv_name: 'CSV Name',
          no_of_posts: 'Total Posts',
          no_of_discards: 'Total Posts failed',
          created_at: 'File Uploaded on',
          status: 'Status',
          reject_reason: '',
        },
        filterByColumn: false,
        filterable: ['csv_name'],
        perPage: 6,
        rowClassCallback() {
          return 'hover:bg-grey-50 funnelRow';
        },
      },
      visibleNav: false,
    };
  },

  async created() {
    this.showLoader();
    const blogId = this.$store.getters.getBlogId;
    try {
      await axios
        .get(`blogpost/${blogId}/import-listing`)
        .then((response) => {
          this.importedFiles = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
    this.hideLoader();
  },

  methods: {
    getReason(row) {
      const reasonJson = row.reject_reason;

      // Check if import job failed
      if (typeof reasonJson.error !== 'undefined') {
        return reasonJson.error.includes('grooveblog_temp')
          ? this.$t('frontend_grooveblog_import_listing_file_not_found_error')
          : reasonJson.error;
      }

      let exceeded = false;
      let reasonString = '';
      let i = 0;

      // For importing failure, get reason string
      while (reasonString.length < 300 && i < reasonJson.length) {
        reasonString += this.$t(
          'frontend_grooveblog_imports_listing_tooltip_error_message',
          {
            row: reasonJson[i].row,
            error: reasonJson[i].error,
          }
        );
        i += 1;
      }

      // Check if reasonString is more than 300 characters
      exceeded = reasonString.length > 300;

      // Update row's show_modal
      const index = this.importedFiles.findIndex((el) => el.id === row.id);
      this.importedFiles[index].show_modal = exceeded;

      return exceeded
        ? this.$t('frontend_grooveblog_import_listing_click_to_see_errors')
        : reasonString;
    },
    openModal(row) {
      if (row.show_modal) {
        this.reason = row.reject_reason;
        this.$refs.reasonModal.open();
      }
    },
    closeModal() {
      this.reason = '';
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
  },

  computed: {
    slotData() {
      return [
        {
          slotName: 'status',
          slotType: 'status',
          value: (props) => {
            const obj = {
              statusClasses: '',
              statusTitle: '',
            };
            if (props.row.status === 0) {
              obj.statusClasses =
                'bg-yellow-extra-light text-yellow-extra-dark';
              obj.statusTitle = 'Processing';
            } else if (props.row.status === 1) {
              obj.statusClasses = 'bg-green-extra-light text-green-extra-dark';
              obj.statusTitle = 'Imported';
            } else {
              obj.statusClasses = 'bg-danger text-danger-extra-dark';
              obj.statusTitle = 'Failed';
            }
            return obj;
          },
        },
        {
          slotName: 'reject_reason',
          slotType: 'reject_reason',
          value: (props) => {
            return props.row.reject_reason;
          },
        }
      ];
    },
  },
};
</script>


<style lang="scss">

.tooltip {
  &.info {
    // $color: rgba(#fd6481, 0.9);

    .tooltip-inner {
      background: #fff;
      color: #191d3a;
      padding: 12px 16px;
      border-radius: 6px;
      box-shadow: 0 0 10px #d5d8e5;
      max-width: 250px;
    }

    .tooltip-arrow {
      border-color: #fff;
    }
  }
}
.webinar-tooltip {
  display: block !important;
  z-index: 10000;
  &.info {
    $color: rgba(#191d3a, 0.9);

    .tooltip-inner {
      background: $color;
      color: #efeff5;
    }

    .tooltip-arrow {
      border-color: $color;
    }
  }
  &.info-dark {
    $color: rgba(#dcdcea, 0.9);

    .tooltip-inner {
      background: $color;
      color: #292b49;
    }

    .tooltip-arrow {
      border-color: $color;
    }
  }
  .tooltip-inner {
    border-radius: 8px;
    font-size: 12px;
    padding: 4px 24px;
  }

  .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    z-index: 1;
  }

  &[x-placement^='top'] {
    margin-bottom: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 0 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^='bottom'] {
    margin-top: 5px;

    .tooltip-arrow {
      border-width: 0 5px 5px 5px;
      border-left-color: transparent !important;
      border-right-color: transparent !important;
      border-top-color: transparent !important;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^='right'] {
    margin-left: 5px;

    .tooltip-arrow {
      border-width: 5px 5px 5px 0;
      border-left-color: transparent !important;
      border-top-color: transparent !important;
      border-bottom-color: transparent !important;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^='left'] {
    margin-right: 5px;

    .tooltip-arrow {
      border-width: 5px 0 5px 5px;
      border-top-color: transparent !important;
      border-right-color: transparent !important;
      border-bottom-color: transparent !important;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.15s, visibility 0.15s;
  }

  &[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.15s;
  }
}



</style>
